import React, {FC} from 'react';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {BoxedIcon} from '../../../components/common/boxedIcon';
import {RuleModel} from '../../../models/api/ruleModel';

/*
 * Props.
 */

interface SettingsSearchRuleProps {
  rule: RuleModel;
}

/*
 * Component.
 */

export const SettingsSearchRuleIcon: FC<SettingsSearchRuleProps> = (props) => {
  const theme = useUserTheme();

  return (
    <BoxedIcon
      name="gearFilledSmall"
      color={PaletteColorsEnum.GREY}
      backgroundColor={theme.palette[PaletteColorsEnum.GREY].shade20}
      borderStyle="solid"
      size={VisualSizesEnum.SMALL}
    />
  );
};
